/* Copyright (c) 2017 Backpack Health LLC */


import DateUtil from './DateUtil';

function compareStrings(a, b) {
  if (a === b) {
    return 0;
  } else if (a > b) {
    return 1;
  } else {
    return -1;
  }
}

function compareDates(date1, date2, isTimestamp) {
  if (date1 === date2) {
    return 0;
  } else if (!date1) {
    return -1;
  } else if (!date2) {
    return 1;
  } else if (DateUtil.isBefore(date1, date2, isTimestamp)) {
    return 1;
  } else {
    return -1;
  }
}

// function compareFlagged(flagged1, flagged2) {
//   if (flagged1 === flagged2) {
//     return 0;
//   } else if (flagged1) {
//     return -1;
//   } else {
//     return 1;
//   }
// }

const SortingUtil = {

  sortHealthEntries(healthEntries, languageCode) {
    return healthEntries.sort((a, b) => compareStrings(a.medliTerm.formattedTermName(languageCode), b.medliTerm.formattedTermName(languageCode)));
  },

  sortOptionListAlphabetically(arrayOfStrings) {
    return arrayOfStrings.sort((a, b) => compareStrings(a.name, b.name));
  },

  sortFiles(files) {
    const filesCopy = files.map((f) => f);
    return filesCopy.sort((a, b) => compareStrings(a.fileName().toLowerCase(), b.fileName().toLowerCase()));
  },

  sortNotes(items) {
    return items.sort((a, b) => {
      const date1 = a.getDate();
      const date2 = b.getDate();
      const string1 = a.getTruncatedText();
      const string2 = b.getTruncatedText();
      const result = compareDates(date1, date2, true);
      return result === 0 ? compareStrings(string1, string2) : result;
    });
  },

  sortFilesAndNotes(items) {
    return items.sort((a, b) => {
      const date1 = a.isNote() ? a.getUpdatedDate() : a.getObservedDate().date;
      const date2 = b.isNote() ? b.getUpdatedDate() : b.getObservedDate().date;
      const string1 = a.isNote() ? a.getTruncatedText() : a.getName();
      const string2 = b.isNote() ? b.getTruncatedText() : b.getName();
      const result = compareDates(date1, date2);
      return result === 0 ? compareStrings(string1, string2) : result;
    });
  },

};

export default SortingUtil;
